/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/** Prompt editor modes for Studio / Portal Graph consumers. */
export const PROMPT_EDITOR_MODE_CATALOGUE = 'catalogue';
export const PROMPT_EDITOR_MODE_INLINE = 'inline';

/**
 * Root tenant flag from getTenantConfig. Only strict `true` enables advanced PMS.
 * @param {{ enableAdvancedPromptManagement?: boolean }|null|undefined} tenant
 * @returns {boolean}
 */
export function isAdvancedPromptManagementEnabled(tenant) {
  return tenant?.enableAdvancedPromptManagement === true;
}

/**
 * Studio prompt editor mode for the current (or target) tenant.
 * @param {{ enableAdvancedPromptManagement?: boolean }|null|undefined} tenant
 * @returns {'catalogue'|'inline'}
 */
export function getPromptEditorMode(tenant) {
  return isAdvancedPromptManagementEnabled(tenant) ? PROMPT_EDITOR_MODE_CATALOGUE : PROMPT_EDITOR_MODE_INLINE;
}
